import { EntitlementsAction } from '@customTypes/ActionTypes';
import { getAllEntitlements, getAssignedEntitlements, } from '@factories/companyInfo';

export const SET_ENTITLEMENTS_INFO = 'SET_ENTITLEMENTS_INFO';

export function getEntitlements() {
    return (dispatch: any) => getAllEntitlements()
        .then(
            (company) => dispatch(setEntitlements(company))
        );
}

export function getCompanyPendingOrFirstCompanyEntitlements() {
    return (dispatch: any) => getAssignedEntitlements()
        .then(
            (company) => dispatch(setEntitlements(company))
        );
}

export function setEntitlements(value: any): EntitlementsAction {
    return {
        type: SET_ENTITLEMENTS_INFO,
        entitlements: value
    };
}
